/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface BalenaReleaseDto
 */
export interface BalenaReleaseDto {
    /**
     *
     * @type {number}
     * @memberof BalenaReleaseDto
     */
    id?: number;
    /**
     *
     * @type {string}
     * @memberof BalenaReleaseDto
     */
    semVersion?: string;
    /**
     *
     * @type {Date}
     * @memberof BalenaReleaseDto
     */
    createdAt?: Date;
    /**
     *
     * @type {boolean}
     * @memberof BalenaReleaseDto
     */
    isValid?: boolean;
}

/**
 * Check if a given object implements the BalenaReleaseDto interface.
 */
export function instanceOfBalenaReleaseDto(
    value: object,
): value is BalenaReleaseDto {
    return true;
}

export function BalenaReleaseDtoFromJSON(json: any): BalenaReleaseDto {
    return BalenaReleaseDtoFromJSONTyped(json, false);
}

export function BalenaReleaseDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): BalenaReleaseDto {
    if (json == null) {
        return json;
    }
    return {
        id: json["id"] == null ? undefined : json["id"],
        semVersion: json["semVersion"] == null ? undefined : json["semVersion"],
        createdAt:
            json["createdAt"] == null ? undefined : new Date(json["createdAt"]),
        isValid: json["isValid"] == null ? undefined : json["isValid"],
    };
}

export function BalenaReleaseDtoToJSON(value?: BalenaReleaseDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        id: value["id"],
        semVersion: value["semVersion"],
        createdAt:
            value["createdAt"] == null
                ? undefined
                : value["createdAt"].toISOString(),
        isValid: value["isValid"],
    };
}
